import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  AppBar,
  Box,
  Toolbar,
  Typography,
  Container,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Select,
  MenuItem,
  List,
  ListItem,
  ListItemText,
  Collapse,
  IconButton,
  FormControl,
  InputLabel,
  Divider,
  Tooltip,
  Avatar,
  Menu,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import ShoppingBagIcon from "@mui/icons-material/ShoppingBag";
import VisibilityIcon from "@mui/icons-material/Visibility";
import OrderTrackingDialog from "./OrderTrackingDialog";
import Grocerylogo from "../../images/Grocerylogo.png";
import "@fontsource/poppins"; // Defaults to weight 400
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Link } from "react-router-dom";

import {
  createTheme,
  ThemeProvider,
  CssBaseline,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import Brightness4Icon from "@mui/icons-material/Brightness4";
import Brightness7Icon from "@mui/icons-material/Brightness7";
import { useNavigate } from "react-router-dom";

import { Menu as MenuIcon } from "@mui/icons-material";
import Header2 from "../../Component/Header2";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";

const CustomerOrders = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [mobileOpen, setMobileOpen] = useState(false);
  const [orders, setOrders] = useState([]);
  const [expandedOrderId, setExpandedOrderId] = useState(null);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [newStatus, setNewStatus] = useState("");
  const [trackingDialogOpen, setTrackingDialogOpen] = useState(false);
  const [trackingOrder, setTrackingOrder] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [selectedOrderId, setSelectedOrderId] = useState(null);
  const [deliveryBoys, setDeliveryBoys] = useState([]);
  const [selectedBoy, setSelectedBoy] = useState("");
  const prefersDarkMode = useMediaQuery("(prefers-color-scheme: dark)");
  const [darkMode, setDarkMode] = useState(prefersDarkMode);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const navigate = useNavigate();
  const statusSteps = [
    "Pending",
    "Processing",
    "Ready To Pack",
    "Shipped",
    "Delivered",
  ];
  useEffect(() => {
    fetchOrders();
  }, []);

  const fetchOrders = () => {
    const shopID = localStorage.getItem("shopkeeperID");
    console.log("✅ Shopkeeper ID:", shopID);

    axios
      .get(`https://sakhisshop.com/api/orders/shop-orders/${shopID}`)
      .then((response) => {
        console.log("Fetched Orders:", response.data); // 👉 Log to inspect fields

        const orders = response.data;

        const activeOrders = orders
          .filter((o) => o.status !== "Delivered" && o.status !== "Cancelled")
          .sort((a, b) => new Date(b.orderDate) - new Date(a.orderDate)); // 🔽 Sort latest first

        setOrders(activeOrders);
      })
      .catch((error) => console.error("Error fetching orders:", error));
  };

  const handleToggleExpand = (orderId) => {
    setExpandedOrderId(expandedOrderId === orderId ? null : orderId);
  };

  const handleOpenTrackingDialog = (order) => {
    setSelectedOrder(order);
    setNewStatus(order.status);
    setTrackingDialogOpen(true);
  };

  const handleCloseTrackingDialog = () => {
    setTrackingDialogOpen(false);
    setSelectedOrder(null);
  };

  const handleUpdateStatus = async () => {
    if (!selectedOrder) return;

    try {
      await axios.put(
        `https://sakhisshop.com/api/orders/update-status/${selectedOrder.orderId}/${newStatus}`,
      );

      // 🔔 Trigger ship logic ONLY if status is Shipped
      if (newStatus === "Shipped") {
        await markAsShipped(selectedOrder.orderId);
      }

      toast.success("Order status updated successfully");
      fetchOrders();
      handleCloseTrackingDialog();
    } catch (error) {
      console.error("Error updating status", error);
      toast.error("Failed to update order status");
    }
  };

  const handleOpenAssignModal = async (orderId, shopID) => {
    const actualShopID = shopID || localStorage.getItem("shopkeeperID"); // fallback if undefined
    console.log("Assigning order:", orderId, "to shopkeeper:", actualShopID);

    if (!actualShopID) {
      console.error("Shop ID missing. Cannot fetch delivery boys.");
      return;
    }

    setSelectedOrderId(orderId);
    setOpenModal(true);
    try {
      const response = await axios.get(
        `https://sakhisshop.com/api/deliveryboys/shop/${actualShopID}`,
      );
      setDeliveryBoys(response.data);
    } catch (error) {
      console.error("Error fetching delivery boys", error);
    }
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setSelectedOrderId(null);
    setSelectedBoy("");
  };

  const handleAssignDeliveryBoy = async () => {
    try {
      await axios.post(
        `https://sakhisshop.com/api/orders/assign-delivery-boy/${selectedOrderId}`,
        null,
        { params: { deliveryBoyId: selectedBoy } },
      );
      toast.success("Delivery Boy Assigned Successfully");

      handleCloseModal();
      fetchOrders();
    } catch (error) {
      console.error("Assignment Failed", error);
      toast.error("Failed to assign delivery boy");
    }
  };

  // Send OTP on Customers Numbers
  const markAsShipped = async (orderId) => {
    try {
      await axios.put(`https://sakhisshop.com/api/orders/${orderId}/ship`);
      alert("Order marked as shipped and OTP sent to customer!");
      // Refresh orders list
    } catch (error) {
      console.error("Error marking as shipped", error);
      alert("Failed to mark as shipped");
    }
  };
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  // const handlePageChange = (page) => {
  //   setActivePage(page);
  //   if (isMobile) setMobileOpen(false);
  // };
  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    // Clear auth tokens or session storage if needed
    localStorage.clear(); // Or remove specific keys
    handleMenuClose();
    navigate("/MyAccountsSignIn"); // Redirect to login page
  };

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box sx={{ pb: 8 }}>
        <ToastContainer position="top-right" autoClose={3000} hideProgressBar />
        {/* AppBar */}
        <Header2 />
        <Toolbar />

        {/* Main Container */}
        <Container sx={{ mt: 5, mb: 6 }}>
          {/* Header */}
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            bgcolor="#3d5a80"
            color="white"
            borderRadius={1}
            p={2}
            mb={3}
          >
            <Box display="flex" alignItems="center" gap={1}>
              <IconButton onClick={() => navigate(-1)} color="warning">
                <ArrowBackIosNewIcon />
              </IconButton>

              <ShoppingBagIcon />

              <Typography
                variant={isMobile ? "h6" : "h5"}
                fontFamily="poppins"
                color="white"
              >
                All Customer Orders
              </Typography>
            </Box>
          </Box>

          {/* Table Section */}
          <Paper elevation={4} sx={{ p: 2, borderRadius: 2 }}>
            <Box sx={{ maxHeight: 600, overflowY: "auto" }}>
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell>
                      <b>CID</b>
                    </TableCell>
                    <TableCell>
                      <b>OrderID</b>
                    </TableCell>
                    <TableCell>
                      <b>OrderDate</b>
                    </TableCell>
                    <TableCell>
                      <b>ContactNumber</b>
                    </TableCell>
                    <TableCell>
                      <b>Address</b>
                    </TableCell>
                    <TableCell>
                      <b>TotalAmount</b>
                    </TableCell>
                    <TableCell>
                      <b>OrderItems</b>
                    </TableCell>
                    <TableCell>
                      <b>Status</b>
                    </TableCell>
                    <TableCell>
                      <b>Actions</b>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {orders.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={6} align="center">
                        No orders found.
                      </TableCell>
                    </TableRow>
                  ) : (
                    orders.map((order) => (
                      <TableRow
                        key={order.orderId}
                        hover
                        sx={{
                          backgroundColor:
                            order.status === "Cancelled"
                              ? "#ffe6e6"
                              : "inherit",
                          opacity: order.status === "Cancelled" ? 0.6 : 1,
                        }}
                      >
                        <TableCell>{order.id}</TableCell>
                        <TableCell>{order.orderId}</TableCell>
                        <TableCell>
                          {order.orderDate
                            ? new Date(order.orderDate).toLocaleDateString(
                                "en-IN",
                                {
                                  day: "2-digit",
                                  month: "2-digit",
                                  year: "numeric",
                                },
                              )
                            : "N/A"}
                        </TableCell>
                        <TableCell>{order.contactNumber}</TableCell>
                        <TableCell>{order.address}</TableCell>
                        <TableCell>
                          ₹ {(order?.totalAmount ?? 0).toFixed(2)}
                        </TableCell>
                        <TableCell>
                          <Button
                            variant="text"
                            size="small"
                            onClick={() => handleToggleExpand(order.orderId)}
                          >
                            View Items
                          </Button>
                          <Collapse in={expandedOrderId === order.orderId}>
                            <List dense>
                              {order?.orderItems?.length > 0 ? (
                                order.orderItems.map((item, index) => (
                                  <ListItem key={index}>
                                    <ListItemText
                                      primary={`${item?.productName || "Unknown"} (Qty: ${item?.quantity || 0} ${item?.uom || ""})`}
                                      secondary={`Price: ₹${(item?.amount || 0).toFixed(2)}`}
                                    />
                                  </ListItem>
                                ))
                              ) : (
                                <Typography>No items found</Typography>
                              )}
                            </List>
                          </Collapse>
                        </TableCell>
                        <TableCell>
                          <Typography
                            variant="body2"
                            color={
                              order.status === "Delivered"
                                ? "green"
                                : "text.primary"
                            }
                          >
                            {order.status}
                          </Typography>
                        </TableCell>
                        <TableCell align="center">
                          {order.status === "Delivered" ? (
                            <Typography
                              variant="body2"
                              color="green"
                              fontWeight="bold"
                            >
                              Completed ✅
                            </Typography>
                          ) : order.status === "Cancelled" ? (
                            <Typography
                              variant="body2"
                              color="error"
                              fontWeight="bold"
                            >
                              Cancelled ❌
                            </Typography>
                          ) : (
                            <>
                              <Tooltip title="Update Status">
                                <span>
                                  <IconButton
                                    color="secondary"
                                    onClick={() =>
                                      handleOpenTrackingDialog(order)
                                    }
                                    disabled={order.status === "Cancelled"}
                                  >
                                    <EditIcon />
                                  </IconButton>
                                </span>
                              </Tooltip>
                              {order.status === "Ready To Pack" &&
                                order.packingOption !== "Pickup" && (
                                  <Tooltip title="Assign Delivery Boy">
                                    <span>
                                      <Button
                                        variant="contained"
                                        onClick={() =>
                                          handleOpenAssignModal(
                                            order.orderId,
                                            order.shopID,
                                          )
                                        }
                                        sx={{ mx: 1 }}
                                        disabled={order.status === "Cancelled"}
                                      >
                                        Assign
                                      </Button>
                                    </span>
                                      
                                  </Tooltip>
                                )}

                              <Tooltip title="Track Order">
                                <span>
                                  <IconButton
                                    onClick={() => setTrackingOrder(order)}
                                    color="primary"
                                    disabled={order.status === "Cancelled"}
                                  >
                                    <VisibilityIcon />
                                  </IconButton>
                                </span>
                              </Tooltip>
                            </>
                          )}
                        </TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </Box>
          </Paper>
        </Container>

        {/* Dialogs */}
        <OrderTrackingDialog
          open={Boolean(trackingOrder)}
          trackingOrder={trackingOrder}
          onClose={() => setTrackingOrder(null)}
        />

        {/* Assign Delivery Boy Dialog */}
        <Dialog
          open={openModal}
          onClose={handleCloseModal}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle>Assign Delivery Boy</DialogTitle>
          <DialogContent dividers>
            <FormControl fullWidth>
              <InputLabel>Select Delivery Boy</InputLabel>
              <Select
                value={selectedBoy}
                onChange={(e) => setSelectedBoy(e.target.value)}
                label="Select Delivery Boy"
              >
                {deliveryBoys.map((boy) => (
                  <MenuItem key={boy.id} value={boy.id}>
                    {boy.name} ({boy.city})
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseModal}>Cancel</Button>
            <Button
              onClick={handleAssignDeliveryBoy}
              variant="contained"
              disabled={!selectedBoy}
            >
              Assign
            </Button>
          </DialogActions>
        </Dialog>

        {/* Update Status Dialog */}
        <Dialog open={trackingDialogOpen} onClose={handleCloseTrackingDialog}>
          <DialogTitle>Update Order Status</DialogTitle>
          <DialogContent>
            <Typography variant="body1">
              Order ID: {selectedOrder?.orderId}
            </Typography>
            <FormControl fullWidth sx={{ mt: 2 }}>
              <InputLabel>Order Status</InputLabel>
              <Select
                value={newStatus}
                onChange={(e) => setNewStatus(e.target.value)}
                label="Order Status"
              >
                {statusSteps.map((status) => (
                  <MenuItem
                    key={status}
                    value={status}
                    disabled={
                      // disable all previous statuses compared to current order
                      statusSteps.indexOf(status) <
                      statusSteps.indexOf(selectedOrder?.status)
                    }
                  >
                    {status}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseTrackingDialog}>Cancel</Button>
            <Button
              onClick={handleUpdateStatus}
              variant="contained"
              color="primary"
            >
              Update
            </Button>
          </DialogActions>
        </Dialog>

        {/* Footer */}
        <ToastContainer />
      </Box>
    </ThemeProvider>
  );
};

export default CustomerOrders;
